module.exports = __webpack_public_path__ + "static/media/dots.71515506.svg";